<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="selected"
    lazy
    full-width
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-bind="$attrs"
        v-model="selected"
        outline
        append-icon="event"
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="selected"
      scrollable>
      <v-btn
        flat
        block
        color="primary"
        @click="$refs.dialog.save(selected); $emit('change')">
        {{ $t('OK') }}
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'DatePicker',

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      modal: false
    }
  },

  computed: {
    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
